<template>
  <div id="app" class="app">
    <transition name="component-fade" mode="out-in">
      <loader v-if="!isHideLoader"/>
    </transition>
    <registration/>
    <div class="app-container">
      <div class="wrapper">
        <div class="wrapper-top">
          <main-header :item="contactsContent" :menu="menuContent" v-if="contactsContent && menuContent"/>
          <transition name="component-fade" mode="out-in">
            <router-view/>
          </transition>
        </div>
<Overlay v-if="contactsContent"/>
        <div class="wrapper-bottom">
          <main-footer :item="contactsContent" :menu="menuContent" v-if="contactsContent && menuContent"/>
        </div>
      </div>
    </div>
    <hidden/>
  </div>


</template>

<style src="@/assets/scss/main.scss" lang="scss"></style>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import Hidden from '@/components/hidden/index.vue';
import MainHeader from '@/components/header/index.vue';
import MainFooter from '@/components/footer/index.vue';
import {isMobile, isIPad} from '@/helpers/variables/index'
import registration from '@/components/popups/registration/index.vue'
import Overlay from '@/assets/overlay/index.vue'

export default {
  name: 'app',
  components: {
    Hidden,
    MainHeader,
    MainFooter,
    registration,
    Overlay
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      isAuthenticated: `auth/isAuthenticated`,
      contactsContent: 'home/contactsContent',
      menuContent: 'home/menuContent',

      translationLoading: `setting/translationLoading`,
      menuLoading: 'home/menuLoading',
      contactsLoading: 'home/contactsLoading',
      homeContentsLoading: 'home/homeContentsLoading',
      articlesLoading: 'home/articlesLoading',
      latestProductsLoading: 'home/latestProductsLoading',

      categoryLoading: 'category/categoryLoading',

      aboutLoading: 'home/aboutLoading',

      getUserInfo: 'userData/userInfo',

      getCurrentOrder: 'order/getCurrentOrder',
      getStatus: 'order/orderStatus',

      historyOrders: 'order/historyOrders',

      productData: 'card/productData',
      productAttributes: 'card/productAttributes',
      popularProducts: 'card/popularProducts',
      userInfo: 'userData/userInfo',

      currentNews: 'home/currentNews'

    }),
    isHideLoader() {
      if (this.$route.name === 'home') {
        if (this.translationLoading && this.menuLoading && this.contactsLoading && this.homeContentsLoading && this.articlesLoading && this.latestProductsLoading) {
          return true
        }
      }
      if (this.$route.name === 'catalog') {
        if (this.translationLoading && this.menuLoading && this.contactsLoading && this.categoryLoading) {
          return true
        }
      }
      if (this.$route.name === 'news') {
        if (this.translationLoading && this.menuLoading && this.contactsLoading && this.articlesLoading) {
          return true
        }
      }
      if (this.$route.name === 'about') {
        if (this.translationLoading && this.menuLoading && this.contactsLoading && this.aboutLoading) {
          return true
        }
      }
      if (this.$route.name === 'contacts') {
        if (this.translationLoading && this.menuLoading && this.contactsLoading) {
          return true
        }
      }
      if (this.$route.name === 'userInfo' && this.getUserInfo) {
        return true
      }
      if (this.$route.name === 'history-orders' && this.historyOrders) {
        return true
      }
      if (this.$route.name === 'current-order' && this.getCurrentOrder && this.getStatus ) {
        return true
      }
      if (this.$route.name === 'card' &&  this.productData && this.popularProducts)  {
        return true
      }
      if (this.$route.name === 'read-more' &&  this.currentNews)  {
        return true
      }
      if (this.$route.name === 'basket' &&  this.getCurrentOrder)  {
        return true
      }
      if (this.$route.name === 'order')  {
        return true
      }
      if (this.$route.name === 'thanks')  {
        return true
      }

      // if (this.$route.name !== 'userInfo' && 'catalog' && 'news' && 'about' && 'contacts') {
      //   return true
      // }

      return false;
    }
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      fetchContacts: 'home/CONTACTS_CONTENT',
      fetchMenu: 'home/MENU_CONTENT',
    }),
  },
  created() {
    this.fetchContacts()
    this.fetchMenu()
  },

  mounted() {
    if (!isMobile.any()) {
      document.querySelector('body').classList.add('hover');
    }
    if (!isIPad.iOS()) {
      document.querySelector('body').classList.add('iPad');
    }
  },

}
</script>
